export default "__VITE_ASSET__CZSWjRD5__"